module.exports = __webpack_public_path__ + "static/media/yodastories2.efd24ad8.gif";